module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('category-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "distributors": "",
      "shopIdDefault": _vm.distributor_id
    },
    on: {
      "update": _vm.storeSearch
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "请输入商品名称或者货号"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsNumberSearch
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.syncAction()
      }
    }
  }, [_vm._v("发布选中的商品")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.batchSyncAction()
      }
    }
  }, [_vm._v("批量发布商品至标签店铺")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "发布商品",
      "name": "relmall"
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleItemsTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 100
    },
    on: {
      "selection-change": _vm.handleItemsSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "src": scope.row.pics[0],
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.item_bn) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "商品价格",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.price) + "元\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.store) + "\n          ")]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.publishtitle,
      "visible": _vm.publishItemVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.publishItemVisible = $event
      }
    }
  }, [
    [_c('h4', {
      staticStyle: {
        "color": "red",
        "text-align": "center"
      }
    }, [_vm._v("\n          发布商品至当前店铺，默认初始化为未分类数据，但不会覆盖已发布的商品。\n        ")])], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.publishItemVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": function($event) {
          return _vm.addStore()
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.submitLoading ? '发布中' : '确认开始发布') + "\n      ")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量发布商品至标签店铺",
      "visible": _vm.publishItemToDistributorsVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.publishItemToDistributorsVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      attrs: {
        "model": _vm.form,
        "label-width": "120px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "指定店铺标签"
      }
    }, [_c('el-select', {
      attrs: {
        "multiple": "",
        "size": "medium",
        "placeholder": "店铺标签"
      },
      model: {
        value: (_vm.distributor_tag_ids),
        callback: function($$v) {
          _vm.distributor_tag_ids = $$v
        },
        expression: "distributor_tag_ids"
      }
    }, _vm._l((_vm.distributor_tags), function(item) {
      return _c('el-option', {
        key: item.tag_id,
        attrs: {
          "label": item.tag_name,
          "value": item.tag_id
        }
      })
    }), 1)], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.publishItemToDistributorsVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": function($event) {
          return _vm.batchSyncItems()
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.submitLoading ? '发布中' : '确认开始发布') + "\n      ")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9996acd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9996acd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/itemrelease.vue
// module id = 2885
// module chunks = 0